// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__K_g89","title":"Images90_title__5868P","images":"Images90_images__7uPxe"};